import { PropertyType } from '../enums/property-type';
import { ListItem } from '../list-item';

/**
 * Représente la définition d'une colonne.
 */
export class ColumnDefinition {
    /** Code de la propriété affichée dans cette colonne. */
    public propertyCode: string = '';

    /** Texte de l'en-tête de la colonne. */
    public header: string = '';

    /** Type de la propriété */
    public type: PropertyType;

    /** Taille en pourcentage */
    public size: number;

    /** Valeur indiquant que la colonne est fixe */
    public isStickyColumn: boolean;

    /**
     * Valeur indiquant si la colonne affiche un attribut personnalisé.
     */
    public custom: boolean;

    /** Valeur des types liste */
    public values: ListItem[];

    /**
     * Format d'affichage de la colonne (Utilisé par les attributs de type Date et Date&Heure.).
     */
    public displayFormat: string = null;

    /**
     * Retourne une instance de Box à partir d'une instance de Box.
     * @param other : Instance de Box.
     * @returns : Instance de Box.
     */
    public static from(other: ColumnDefinition) {
        if (!!other) {
            const instance = new ColumnDefinition();

            instance.propertyCode = other.propertyCode;
            instance.header = other.header;
            instance.type = other.type;
            instance.size = other.size;
            instance.isStickyColumn = other.isStickyColumn;
            instance.custom = other.custom;
            instance.displayFormat = other.displayFormat;
            instance.values = ListItem.fromArray(other.values);

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne un tableau d'instances de Box à partir d'un tableau d'instances de Box.
     * @param other : Tableau d'instances de Box.
     * @returns : Tableau d'instances de Box.
     */
    public static fromArray(others: ColumnDefinition[]) {
        if (!!others) {
            let columnDefinitions: ColumnDefinition[] = [];

            others.forEach((x) => {
                const columnDefinition = ColumnDefinition.from(x);
                columnDefinitions.push(columnDefinition);
            });

            return columnDefinitions;
        } else {
            return null;
        }
    }

    /**
     * Retourne une valeur indiquant si 2 instances de definition de colonnes sont égales (hormis la taille).
     * @param instance1 : 1ere instance de definition de colonnes.
     * @param instance2 : 2nde instance de definition de colonnes.
     * @returns : true si les 2 instances sont égales.
     */
    public static Equals(instance1: ColumnDefinition, instance2: ColumnDefinition) {
        if (instance1.custom != instance2.custom) {
            return false;
        }

        if (instance1.displayFormat != instance2.displayFormat) {
            return false;
        }

        if (instance1.header != instance2.header) {
            return false;
        }

        if (instance1.isStickyColumn != instance2.isStickyColumn) {
            return false;
        }

        if (instance1.propertyCode != instance2.propertyCode) {
            return false;
        }

        if (instance1.type != instance2.type) {
            return false;
        }

        if (instance1.values && instance2.values) {
            if (instance1.values.length != instance2.values.length) {
                return false;
            }

            for (let index = 0; index < instance1.values.length; index++) {
                if (instance1.values[index].text !== instance2.values[index].text || instance1.values[index].value !== instance2.values[index].value) {
                    return false;
                }
            }
        }

        return true;
    }
}
